//
// Generated class ArchivedTicketLinesGroup
//

/// <reference path="ArchivedTicketLinesGroup_ManagedObject.ts" />

class ArchivedTicketLinesGroup extends ArchivedTicketLinesGroup_ManagedObject
{
}
